module.exports = __webpack_public_path__ + "static/media/Celeb2.7db8a5b0.jpg";